import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import AddSymbolComponent from "assets/icons/svg/AddSymbokComponent";
import ArrowDSVG from "assets/icons/svg/arrow-details";
import MemberDrawerSvg from "assets/icons/svg/memberIcon";
import RemoveParticipantSvgComponent from "assets/icons/svg/removeParticipant";
import ReturnSvgComponent from "assets/icons/svg/returnSvg";
import RightArrowSvg from "assets/icons/svg/RightArrowSvg";
import { InputField, LabelField, SelectField } from "components";
import MyButton from "components/MyButton";
import TextArea from "components/TextArea";
import { FieldArray, FormikProvider, useFormik } from "formik";
import { useSearch } from "hook";
import { SubHeader } from "layout/SubHeader";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import MemberService from "Lib/API/Member";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useHistory } from "react-router";
import Select, { components } from "react-select";
import { CreateInvoiceSchema } from "../../../ValidationSchema";
import { DateFormetContext } from "../../../../app/App.js";
import "./index.scss";
import { CheckFloatValue } from "../../../../utils/functions";
import { toastr } from "react-redux-toastr";

const CreateInvoice = () => {
  const dateFormet = React.useContext(DateFormetContext);
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [percenDiscount, setPercentDiscount] = useState();
  const [discountType, setDiscountType] = useState("%");
  const [subTotalVal, setSubTotalVal] = useState(0);
  const [totalTaxs, setTotalTaxs] = useState(0);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [prodLoading, setProdLoading] = React.useState(false);
  const [contactsList, setContactsList] = React.useState([]);
  const [productslist, setProductsList] = React.useState([]);
  const [search, setSearch] = useState(undefined);
  const [searchProduct, setSearchProduct] = useState(undefined);
  const { searchAction } = useSearch({ action: setSearch });
  const { searchAction: searchProductAction } = useSearch({
    action: setSearchProduct,
  });
  const [toValue, setToValue] = useState(null);

  const initialValues = {
    to: undefined,
    emailAddress: undefined,
    billingAddress: undefined,
    member_id: undefined,
    member_serial: undefined,
    account_id: undefined,
    comments: undefined,
    invoiceDate: moment().utcOffset("+0100").format(dateFormet),
    dueDate: moment()
      .add(1 * 1, "days")
      .utcOffset("+0100")
      .utcOffset("+0100")
      .format(dateFormet),
    noOfPayment: 1,
    interval: "30 days",
    addInvoice: [
      {
        total: 0,
        selected: undefined,
        productN: undefined,
        productSN: undefined,
        tax: 0,
        qty: 1,
        price: 0,
        desc: undefined,
      },
    ],
    add_discount: 0,
    dis_type: "",
  };

  const enableLoading = (value) => {
    setLoading(value);
  };

  useEffect(() => {
    //if (isMount) return;

    async function fetchMyAPI() {
      enableLoading(true);

      const token = await getAccessTokenSilently();
      await MemberService.getContacts(token, search).then((res) => {
        if (res?.contacts) {
          res.contacts.map((item) => {
            item.id = item.member_id;
            item.label = item?.first_name + " " + item?.last_name;
            item.value = item._id;
            return item;
          });
          setContactsList(res?.contacts);
        }

        enableLoading(false);
      });
    }

    fetchMyAPI();
  }, [search]);

  useEffect(() => {
    async function fetchMyAPI() {
      setProdLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getFilteredProducts(
        "filter?active=true",
        token
      ).then((res) => {
        if (res?.length) {
          res.map((item) => {
            item.id = item.prod_id;
            item.label = item?.prod_name;
            item.value = item.prod_id;
            return item;
          });
          setProductsList(res);
        }
        setProdLoading(false);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    }

    fetchMyAPI();
  }, [getAccessTokenSilently]);

  const getCalcTotal = (subTotal) => {
    if (!discountType)
      return CheckFloatValue(subTotal)
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    else {
      return CheckFloatValue(
        discountType === "$"
          ? subTotal - formik.values?.add_discount
          : subTotal - (subTotal * Number(formik.values?.add_discount)) / 100
      )
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    // paddingTop: "8px",
    // paddingBottom: "8px",
    height: "48px",
  };
  const productSelectStyles = {
    container: (styles) => ({
      ...styles,
      marginTop: "25px",
    }),
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
    IndicatorSeparator: (styles) => ({ display: "none" }),
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <RightArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const dateOptions = ["30 days", "60 days", "90 days", "120 days"];

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: CreateInvoiceSchema,
    onSubmit: async (values) => {
      const dataToSend = {
        member_id: values?.member_id,
        bill_to: values?.to,
        member_serial: values?.member_serial,
        num_of_payment: values?.noOfPayment,
        interval: Number(values.interval.split(" ")[0]),
        comments: values?.comments,
        billing_address: values?.billingAddress,
        account_id: values?.account_id,
        product_details: values?.addInvoice?.map((data) => {
          return {
            prod_name: data.productN,
            prod_desc: data.desc,
            qty: data.qty,
            prod_price: data.price,
            prod_tax: data.tax || 0,
          };
        }),
        payment_amount: {
          sub_total: subTotalVal,
          total: getCalcTotal(subTotalVal),
          discount: {
            dis_type: discountType,
            dis_value: values?.add_discount,
          },
        },
      };
      setSubmitLoading(true);
      const token = await getAccessTokenSilently();
      await AuthService.createInnvoice(token, dataToSend).then((res) => {
        history.push("/invoices");
        setSubmitLoading(false);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    },
  });

  const handelToChangeAction = (value) => {
    setToValue(value);
    formik.setFieldValue("emailAddress", value?.email_address);
    formik.setFieldValue("to", `${value?.first_name + " " + value?.last_name}`);
    formik.setFieldValue("member_id", String(value?._id));
    formik.setFieldValue("member_serial", String(value?.member_id));
    formik.setFieldValue("account_id", String(value?.account_id));
    formik.setFieldValue("billingAddress", value?.location?.formattedAddress);
  };

  const handlePaymentChange = (e) => {
    const values = e.target.value;
    const getDay = Number(formik.values.interval.split(" ")[0]);

    formik.setFieldValue("noOfPayment", values);
    formik.setFieldValue(
      "dueDate",
      moment()
        .add(getDay * values, "days")
        .utcOffset("+0100")
        .utcOffset("+0100")
        .utcOffset("+0100")
        .format(dateFormet)
    );
  };
  var totalArray = [];
  var taxsArray = [];
  const getTotalPrice = (q, price, tax, index) => {
    if (!price) return 0;
    taxsArray[index] = (price * tax * q) / 100;
    totalArray[index] = price * q + (price * tax * q) / 100;
    return totalArray[index];
  };

  const formatOptionLabel = ({ label, id, profile_img }) => {
    return (
      <div className="dropdown-container" key={id}>
        <div className="dropdown-member-icon">
          <MemberDrawerSvg height={20} width={20} />
        </div>
        <div className="icon-name-container">
          {profile_img ? (
            <img
              height={40}
              width={40}
              className="rounded-circle"
              src={profile_img}
              alt=""
            />
          ) : (
            <Avatar style={{ width: 30, height: 30 }}>
              {label?.charAt(0)}
            </Avatar>
          )}
          <div className="name-container">
            <div>{label}</div>
            <div className="id-container">#{id}</div>
          </div>
        </div>
        <div className="return-icon">
          <ReturnSvgComponent width={24} height={24} />
        </div>
      </div>
    );
  };
  const formatProductOptionLabel = ({
    value,
    label,
    customAbbreviation,
    isFocused,
  }) => {
    return (
      <div className="dropdown-container">
        <div className="icon-name-container">
          <div className="name-container">
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="school-classes pr-12 pt-5">
      <div className="school-classes">
        <div className="header">
          <div className="header-tittle mb-5">
            <ArrowDSVG
              style={{ cursor: "pointer" }}
              onClick={() => history.goBack()}
            />
            <SubHeader
              className="subheader"
              {...{
                title: "Create New Invoices",
              }}
            />
          </div>
        </div>
      </div>
      <div className="form-container">
        <div>
          <Card className="card card-custom w-100">
            <div className="invoice-form">
              <form className="form-data">
                <Row
                  style={{ justifyContent: "center", alignItems: "baseline" }}
                >
                  <Col className="col-sm-3 mr-20">
                    <div className="d-flex">
                      <LabelField title={"To"} />
                      <label
                        style={{
                          fontSize: 14,
                          textAlign: "start",
                          fontWeight: 500,
                          color: "red",
                        }}
                      >
                        *
                      </label>
                    </div>
                    <Select
                      mandatory={true}
                      {...{
                        formik,
                        name: "to",
                      }}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={contactsList}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={handelToChangeAction}
                      value={toValue}
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                  <Col className="col-sm-3 mr-20">
                    <InputField
                      mandatory={true}
                      {...{
                        formik,
                        title: "Email Address",
                        name: "emailAddress",
                        placeholder: "asd@mail.com",
                      }}
                      style={{ height: "48px" }}
                    />
                  </Col>
                  <Col className="col-sm-2">
                    <InputField
                      mandatory={true}
                      {...{
                        formik,
                        title: "Invoice Date",
                        placeholder: "Invoice Date",
                        name: "invoiceDate",
                      }}
                      style={{ height: "48px" }}
                      disabled
                    />
                  </Col>
                  <Col className="col-sm-2">
                    <InputField
                      mandatory={true}
                      {...{
                        formik,
                        title: "Due Date",
                        placeholder: "Year",
                        name: "dueDate",
                      }}
                      style={{ height: "48px" }}
                      disabled
                    />
                  </Col>
                </Row>
                <Row
                  style={{ justifyContent: "center", alignItems: "baseline" }}
                >
                  <Col className="col-sm-3 mt-15 mr-20">
                    <TextArea
                      mandatory={true}
                      {...{
                        formik,
                        title: "Billing Address",
                        name: "billingAddress",
                        placeholder: "Write the billing address here",
                        checkValidation: true,
                      }}
                    />
                  </Col>
                  <Col className="col-sm-3 mt-15 mr-20">
                    <TextArea
                      {...{
                        formik,
                        title: "Comments",
                        name: "comments",
                        placeholder: "Write the comments here",
                      }}
                    />
                  </Col>
                  <Col className="col-sm-2 mt-8">
                    <InputField
                      mandatory={true}
                      {...{
                        type: "number",
                        formik,
                        title: "Number of payments",
                        name: "noOfPayment",
                        placeholder: "1",
                        checkValidation: true,
                        handleChange: handlePaymentChange,
                      }}
                      style={{ height: "48px" }}
                    />
                  </Col>
                  <Col className="col-sm-2 mt-8">
                    <SelectField
                      mandatory={true}
                      {...{
                        formik,
                        title: "Interval",
                        name: "interval",
                        items: dateOptions,
                        value: formik.values.interval,
                        placeholder: "",
                      }}
                      style={{ height: "48px" }}
                      onClick={(data) => {
                        const getDay = Number(data.split(" ")[0]);
                        formik.setFieldValue(
                          "dueDate",
                          moment()
                            .add(getDay * formik.values.noOfPayment, "days")
                            .utcOffset("+0100")
                            .utcOffset("+0100")
                            .format(dateFormet)
                        );
                        formik.setFieldValue("interval", data);
                      }}
                    />
                  </Col>
                </Row>
              </form>
            </div>
            <div>
              <div className="table-format-head">
                <Row className="table-header">
                  <Col className="mt-3 mb-3">#</Col>
                  <Col className="mt-3 mb-3 col-sm-2">PRODUCT NAME</Col>
                  <Col className="mt-3 mb-3 col-sm-2">DESCRIPTION</Col>
                  <Col className="mt-3 mb-3 ">QTY</Col>
                  <Col className="mt-3 mb-3">PRICE</Col>
                  <Col className="mt-3 mb-3">TAX</Col>
                  <Col className="mt-3 mb-3">TOTAL</Col>
                  <Col className="mt-3 mb-3"></Col>
                </Row>
              </div>
              <div>
                <FormikProvider value={formik}>
                  <FieldArray
                    name="addInvoice"
                    render={({ insert, remove, pop, push }) => (
                      <div className="cell-format-head">
                        {formik?.values?.addInvoice?.length
                          ? formik?.values?.addInvoice.map(
                              (_element, index) => (
                                <>
                                  <div className="mb-0.5" key={index}>
                                    <Row className="table-header">
                                      <Col className="mt-3 mb-3">
                                        {_element?.productSN}
                                      </Col>
                                      <Col className="mt-3 mb-3 col-sm-2">
                                        <div className="product-name">
                                          <Select
                                            mandatory={true}
                                            {...{
                                              formik,
                                              name: `addInvoice.${index}.selected`,
                                            }}
                                            formatOptionLabel={
                                              formatProductOptionLabel
                                            }
                                            onInputChange={(text) =>
                                              searchProductAction(text)
                                            }
                                            value={
                                              formik.values.addInvoice[index]
                                                ?.selected
                                            }
                                            onChange={(option) => {
                                              formik.setFieldValue(
                                                `addInvoice.${index}.selected`,
                                                option
                                              );
                                              formik.setFieldValue(
                                                `addInvoice.${index}.productN`,
                                                option.prod_name
                                              );
                                              formik.setFieldValue(
                                                `addInvoice.${index}.desc`,
                                                option.description || " "
                                              );
                                              formik.setFieldValue(
                                                `addInvoice.${index}.productSN`,
                                                option.id || " "
                                              );
                                              formik.setFieldValue(
                                                `addInvoice.${index}.tax`,
                                                option.prod_tax || 0
                                              );
                                              formik.setFieldValue(
                                                `addInvoice.${index}.price`,
                                                option.price || 0
                                              );
                                              formik.setFieldValue(
                                                `addInvoice.${index}.qty`,
                                                1
                                              );
                                            }}
                                            options={productslist}
                                            styles={productSelectStyles}
                                            isLoading={prodLoading}
                                          />
                                        </div>
                                      </Col>
                                      <Col className="mt-3 mb-3 col-sm-2">
                                        <div className="product-name">
                                          <InputField
                                            {...{
                                              formik,
                                              name: `addInvoice.${index}.desc`,
                                              placeholder:
                                                "Product’s description",
                                            }}
                                            style={{
                                              color:
                                                formik?.values?.addInvoice[
                                                  index
                                                ]?.price < 0
                                                  ? "#F1585E"
                                                  : "#3F4254",
                                            }}
                                          />
                                        </div>
                                      </Col>
                                      <Col className="mt-3 mb-3 ">
                                        <div className="product-qty">
                                          <InputField
                                            {...{
                                              formik,
                                              type: "number",
                                              name: `addInvoice.${index}.qty`,
                                              placeholder: "0",
                                            }}
                                            onKeyPress={(event) => {
                                              if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                              }
                                            }}
                                          />
                                        </div>
                                      </Col>
                                      <Col className="mt-3 mb-3">
                                        <div className="product-qty">
                                          <InputField
                                            {...{
                                              formik,
                                              type: "number",
                                              name: `addInvoice.${index}.price`,
                                              placeholder: "0.00",
                                              min: 0,
                                            }}
                                            style={{
                                              color:
                                                formik?.values?.addInvoice[
                                                  index
                                                ]?.price < 0
                                                  ? "#F1585E"
                                                  : "#3F4254",
                                            }}
                                          />
                                        </div>
                                      </Col>
                                      <Col className="mt-3 mb-3">
                                        <div className="product-qty">
                                          <InputField
                                            {...{
                                              type: "number",
                                              formik,
                                              name: `addInvoice.${index}.tax`,
                                              placeholder: "17.0% S",
                                            }}
                                            onKeyPress={(event) => {
                                              if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                              }
                                            }}
                                          />
                                        </div>
                                      </Col>
                                      <Col className="mt-3 mb-3">
                                        <div
                                          className="total-money"
                                          style={{
                                            color:
                                              formik?.values?.addInvoice[index]
                                                ?.price < 0
                                                ? "#F1585E"
                                                : "#3F4254",
                                          }}
                                        >
                                          <>
                                            ${" "}
                                            {getTotalPrice(
                                              formik?.values?.addInvoice[index]
                                                ?.qty,
                                              formik?.values.addInvoice[index]
                                                ?.price,
                                              formik?.values?.addInvoice[index]
                                                ?.tax,
                                              index
                                            )}
                                          </>
                                        </div>
                                      </Col>
                                      <Col className="mt-3 mp-20">
                                        <div
                                          style={{ cursor: "pointer" }}
                                          className="remove-another-line"
                                          disabled={true}
                                          onClick={() => {
                                            remove(index);
                                            // formik.setFieldValue(
                                            //   `addInvoice.${index}.selected`,
                                            //   {}
                                            // );
                                          }}
                                        >
                                          <div>
                                            <RemoveParticipantSvgComponent />
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                  <hr style={{ marginTop: "-20px" }} />
                                </>
                              )
                            )
                          : ""}
                        <div className="add-line">
                          <div
                            className="add-another-line"
                            disabled={true}
                            onClick={() => push()}
                          >
                            <AddSymbolComponent />
                            <div className="add-symbol"></div>
                            <div className="add-another-line-text">
                              Add Lines
                            </div>
                          </div>
                        </div>
                        <div className="sub-total">
                          <div className="cal-total">
                            <div className="total-text">Subtotal</div>
                            <div className="discount">
                              <div className="discount-text">Discount</div>
                              <div className="discount-radio">
                                <RadioGroup
                                  row
                                  aria-label="date"
                                  name="additinalDiscount"
                                  value={formik.values["additinalDiscount"]}
                                  className="ml-5"
                                  onChange={(val) =>
                                    formik.setFieldValue &&
                                    formik.setFieldValue(
                                      "additinalDiscount",
                                      val.target.value
                                    )
                                  }
                                  {...{
                                    formik,
                                    name: "dis_type",
                                  }}
                                >
                                  <FormControlLabel
                                    value={"dollar"}
                                    onClick={() => {
                                      setPercentDiscount(false);
                                      setDiscountType("$");
                                    }}
                                    control={<Radio />}
                                    label="$"
                                  />
                                  <FormControlLabel
                                    value={"percentage"}
                                    onClick={() => {
                                      setPercentDiscount(true);
                                      setDiscountType("%");
                                    }}
                                    control={<Radio />}
                                    label="%"
                                  />
                                </RadioGroup>
                              </div>
                            </div>
                            <div className="tax-text" style={{ marginTop: 11 }}>
                              TAX
                            </div>
                            <div className="total-text">Total</div>
                          </div>
                          <div className="cal-value">
                            <div className="total-value">
                              {setSubTotalVal(
                                totalArray.reduce((a, b) => a + b, 0)
                              )}
                              ${subTotalVal}
                            </div>
                            <div className="calc-discount mb-7">
                              <InputField
                                {...{
                                  formik,
                                  title: "none",
                                  type: "number",
                                  name: "add_discount",
                                  placeholder: "10%",
                                }}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            <div className="tax-value">
                              {setTotalTaxs(
                                taxsArray.reduce((a, b) => a + b, 0)
                              )}
                              ${totalTaxs}
                            </div>
                            <div className="total-text">
                              ${getCalcTotal(subTotalVal)}
                            </div>
                          </div>
                        </div>
                        <div className="issue-invoice-button">
                          <div className="button-container">
                            <MyButton
                              loading={submitLoading}
                              disabled={!formik.isValid}
                              content="Issue Invoice"
                              onClick={() => formik.handleSubmit()}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  />
                </FormikProvider>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CreateInvoice;
